import {useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import {
  createAuthUserWithEmailAndPassword,
  createUserDocumentFromAuth,
} from "../../utils/firebase/firebase.utils";
import FormInput from "../form-input/form-input.component";
import Button from "../button1/button.component";
import {UserContext} from "../../context/user.context";

const defaultFormField = {
  displayName: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const SignUpForm = () => {
  const [formFields, setFormFields] = useState(defaultFormField);
  const [error, setError] = useState("");
  const {displayName, email, password, confirmPassword} = formFields;
  const {setCurrentUser} = useContext(UserContext);
  const navigate = useNavigate();

  const resetFormfield = () => setFormFields(defaultFormField);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords don't match.");
      return;
    }

    try {
      const {user} = await createAuthUserWithEmailAndPassword(email, password);
      setCurrentUser(user);
      await createUserDocumentFromAuth(user, {displayName});
      resetFormfield();
      navigate("/blog");
    } catch (err) {
      if (err.code === "auth/email-already-in-use") {
        setError("An account with this email already exists.");
      } else if (err.code === "auth/weak-password") {
        setError("Password should be at least 6 characters.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
  };

  const handleChange = (event) => {
    const {name, value} = event.target;
    setFormFields({...formFields, [name]: value});
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <FormInput
        label="Display Name"
        type="text"
        onChange={handleChange}
        required
        name="displayName"
        value={displayName}
        placeholder="Your name"
      />

      <FormInput
        label="Email"
        type="email"
        onChange={handleChange}
        required
        name="email"
        value={email}
        placeholder="you@example.com"
      />

      <FormInput
        label="Password"
        type="password"
        onChange={handleChange}
        required
        name="password"
        value={password}
        placeholder="At least 6 characters"
      />

      <FormInput
        label="Confirm Password"
        type="password"
        onChange={handleChange}
        required
        name="confirmPassword"
        value={confirmPassword}
        placeholder="Re-enter your password"
      />

      {error && <p className="auth-error">{error}</p>}

      <Button type="submit">Create Account</Button>
    </form>
  );
};

export default SignUpForm;
